import React            from 'react';
import { words }        from '../../utils/dictionary';
import colors           from '../../utils/colors';
import { makeStyles }   from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    text: {
        height: 30,
        color:  '#FFF'
    },
    text_field: {
        height:          50,
        paddingLeft:     10,
        paddingRight:    10,
        backgroundColor: colors.dark,
        border:          '1px solid #FFF',
        borderRadius:    '999em',
        fontSize:        20,
        color:           '#FFF',
        marginTop:       10,
        marginBottom:    10,
        transition:      'width 1s',
        '&:focus': {
          outline: 'none',
          border:  '2px solid #FFF',
          height:   48
         },
        '&::placeholder': {
          color: '#FFF',
         },
      }
}))

type FormProps = {
  lang:          string;
  code:          string;
  codeErr:       string;
  showCodeInput: boolean;
  setCode:       (val: string) => void;
}

const Form: React.FC<FormProps> = ({ 
  lang,
  showCodeInput,
  code,
  codeErr,
  setCode
}) => {

  const classes = useStyles();


  const changeInputValue = (e: React.FormEvent) => {

    e.preventDefault();

    const target = e.target as HTMLInputElement;
    setCode(target.value)
  }


  const inputStyle = React.useMemo(() => {
    return{ width: showCodeInput ? 300 : 0 }
  },[showCodeInput])


  return (
    <>
        <div className = { classes.text }>
            { codeErr }
        </div>
        <input 
            className    = { classes.text_field }
            style        = { inputStyle }
            dir          = { code.length ? 'ltr' : 'rtl' }
            type         = "text"
            id           = "code"
            autoComplete = "off"
            value        = { code }
            placeholder  = { `${ words['enterTeacherCode'][lang] }` }
            onChange     = { changeInputValue }
         />
    </>
  );
}




export default Form;

